"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.X_SCALE_DEFAULT = void 0;
var constants_1 = require("../../../scales/constants");
exports.X_SCALE_DEFAULT = {
    type: constants_1.ScaleType.Ordinal,
    nice: false,
    desiredTickCount: 10,
};
//# sourceMappingURL=scale_defaults.js.map